import React from 'react';

const MainPart = ({ children }) => {
    return (
        <main className="" dir="ltr">
            {children}
        </main>
    );
};

export default MainPart;
